module.exports = __webpack_public_path__ + "img/4.5f0783b8.jpg";